import type { z } from "zod";

export interface EventDefinition<
  Name extends string,
  Version extends number,
  ValueSchema extends z.ZodTypeAny,
  MetadataSchema extends z.ZodTypeAny,
> {
  readonly eventName: Name;
  readonly eventVersion: Version;
  readonly valueSchema: ValueSchema;
  readonly metadataSchema: MetadataSchema;
}

export function defineEvent<
  Name extends string,
  Version extends number,
  ValueSchema extends z.ZodTypeAny,
  MetadataSchema extends z.ZodTypeAny,
>(args: {
  eventName: Name;
  eventVersion: Version;
  valueSchema: ValueSchema;
  metadataSchema: MetadataSchema;
}): EventDefinition<Name, Version, ValueSchema, MetadataSchema> {
  return args;
}

export type AnyEventDefinition = EventDefinition<
  string,
  number,
  z.ZodTypeAny,
  z.ZodTypeAny
>;
